import { Mentorships } from "@/components/dashboard/mentorships.tsx";
import { OverallHealth } from "@/components/dashboard/overall-health.tsx";

export function Dashboard() {
  return (
    <div className="px-8 pb-20 pt-4">
      <OverallHealth />

      <hr className="my-9 border-t border-gray-200" />
      <Mentorships />
    </div>
  );
}
